import { render, staticRenderFns } from "./FullTemplate.vue?vue&type=template&id=5c260247&"
import script from "./FullTemplate.vue?vue&type=script&lang=js&"
export * from "./FullTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FullTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports